import { render } from "./data_notfound.vue?vue&type=template&id=4a5a57e8"
import script from "./data_notfound.vue?vue&type=script&lang=js"
export * from "./data_notfound.vue?vue&type=script&lang=js"

import "./data_notfound.vue?vue&type=style&index=0&id=4a5a57e8&lang=scss"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__